import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { dialogFieldLabelSx, dialogRequiredMarkSx } from '../../../constants/dialogSx'

export default function RbacDialogFieldLabel({
  children,
  required = false,
  htmlFor,
  sx,
  className,
  requiredClassName
}) {
  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      className={className}
      sx={sx === undefined && !className ? dialogFieldLabelSx : sx}
    >
      {children}
      {required ? (
        requiredClassName ? (
          <span className={requiredClassName}> *</span>
        ) : (
          <Box component="span" sx={dialogRequiredMarkSx}>
            {' '}
            *
          </Box>
        )
      ) : null}
    </Typography>
  )
}
